<template>
  <v-row>
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </div>

      <!-- list filters -->
      <v-card>
        <v-card-title> Filtrar </v-card-title>
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="filtrar"
        >
          <v-row class="px-2 ma-0">
            <v-col
              cols="12"
              sm="2"
            >
              <VSelect
                v-model="idBotSelecionado"
                :items="botsDisponiveis"
                item-text="nome"
                item-value="id"
                label="Bot"
                outlined
                dense
                clearable
                :rules="[validators.select]"
                @change="idArvoreSelecionada = null"
              />
            </v-col>

            <v-col
              cols="12"
              sm="2"
            >
              <VSelect
                v-model="idArvoreSelecionada"
                :disabled="!idBotSelecionado"
                :items="arvoresDisponiveis"
                item-text="nome"
                item-value="id"
                label="Árvore"
                outlined
                dense
                clearable
                :rules="[validators.select]"
                @click="getArvores"
              />
            </v-col>

            <v-col
              cols="12"
              sm="2"
            >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Período de:"
                    outlined
                    dense
                    color="primary"
                    clearable
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoInicio"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @input="menu1 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="2"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    label="Período até:"
                    outlined
                    dense
                    color="primary"
                    clearable
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoFim"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @input="menu2 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              class="d-flex justify-center-around"
            >
              <v-btn
                color="primary"
                :loading="loadingButton"
                class="mx-3"
                type="submit"
              >
                <span>Filtrar</span>
              </v-btn>

              <v-btn
                v-if="filtragemFeita"
                color="primary"
                class="mx-3"
                @click="downloadExcel"
              >
                <v-icon>{{ icons.mdiFileExcelOutline }}</v-icon>
                <span>Exportar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>

    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loadingComponentes"
          indeterminate
        />
      </div>
      <v-card
        v-if="filtragemFeita"
        flat
      >
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <grafico-atendimentos-bot
              :dados-atendimentos="atendimentosBot"
              :dados-bot="dadosBot"
            />
          </v-col>

          <v-divider :vertical="$vuetify.breakpoint.name === 'xs' ? false : true"></v-divider>

          <v-col
            cols="12"
            sm="6"
          >
            <arvore-relatorio-view
              :dados-bot="arvore"
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-card-text>
          <div class="d-flex align-center mb-2 flex-wrap">
            <span class="text-subtitle-1 font-weight-semibold">Interações do chatbot por cliente</span>
            <v-chip
              small
              class="ml-3"
              color="primary"
              outlined
            >
              {{ sessoesPorCliente.length }} sessão(ões) no período
            </v-chip>
            <v-chip
              small
              class="ml-2"
              color="success"
              dark
            >
              {{ qtdeTicketsAbertos }} ticket(s) abertos
            </v-chip>
            <v-chip
              small
              class="ml-2"
              color="grey"
            >
              {{ qtdeSessoesSemTicket }} sessão(ões) sem ticket
            </v-chip>
          </div>

          <div class="d-flex align-center mb-4 flex-wrap">
            <span class="text-caption text--secondary">Por cliente (sem repetir quem apareceu em mais de uma sessão):</span>
            <v-chip
              small
              class="ml-2"
              color="success"
              outlined
            >
              {{ qtdeClientesComTicket }} cliente(s) abriram ticket
            </v-chip>
            <v-chip
              small
              class="ml-2"
              color="grey"
              outlined
            >
              {{ qtdeClientesSemTicket }} cliente(s) nunca abriram ticket
            </v-chip>
          </div>

          <v-text-field
            v-model="buscaCliente"
            label="Buscar por nome do cliente"
            :prepend-inner-icon="icons.mdiMagnify"
            outlined
            dense
            clearable
            class="mb-3"
            style="max-width: 320px"
          />

          <v-data-table
            :headers="headersSessoesPorCliente"
            :items="sessoesFiltradas"
            :loading="loadingInteracoesClientes"
            no-data-text="Nenhuma interação encontrada no período selecionado."
            :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
            dense
          >
            <template #item.dataInicio="{ item }">
              {{ formatarDataHora(item.dataInicio) }}
            </template>

            <template #item.qtdeInteracoes="{ item }">
              {{ item.historico.length }}
            </template>

            <template #item.abriuTicket="{ item }">
              <v-chip
                x-small
                :color="abriuTicket(item) ? 'success' : 'grey'"
                :outlined="!abriuTicket(item)"
                dark
              >
                {{ abriuTicket(item) ? 'Sim' : 'Não' }}
              </v-chip>
            </template>

            <template #item.ultimaMensagem="{ item }">
              <v-tooltip
                bottom
                max-width="400"
              >
                <template #activator="{ on, attrs }">
                  <span
                    class="d-inline-block text-truncate"
                    style="max-width: 260px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ ultimaMensagemDoCliente(item) }}
                  </span>
                </template>
                <span>{{ ultimaMensagemDoCliente(item) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api'
import { mdiCalendar, mdiFileExcelOutline, mdiMagnify } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import Vue from 'vue'
import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'
import GraficoAtendimentosBot from '@/views/relatorio/bot/GraficoAtendimentosBot.vue'
import ArvoreRelatorioView from '@/views/relatorio/bot/ArvoreRelatorioView.vue'
import ChatBotService from '@/services/modules/ChatBotService'
import RelatorioService from '@/services/modules/RelatorioService'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    GraficoAtendimentosBot,
    ArvoreRelatorioView,
  },

  setup() {
    const botsDisponiveis = ref([])
    const idBotSelecionado = ref(null)
    const arvoresDisponiveis = ref([])
    const idArvoreSelecionada = ref(null)
    const loading = ref(true)
    const loadingComponentes = ref(false)
    const loadingButton = ref(false)
    const loadingExcel = ref(false)
    const filtragemFeita = ref(false)
    const atendimentosBot = ref({})
    const pesquisaSatisfacaoBot = ref({})
    const arvore = ref([])
    const dadosBot = ref({})
    const interacoesClientes = ref([])
    const loadingInteracoesClientes = ref(false)

    const headersSessoesPorCliente = [
      { text: 'Cliente', value: 'nomeCliente' },
      { text: 'Início da sessão', value: 'dataInicio' },
      { text: 'Interações', value: 'qtdeInteracoes' },
      { text: 'Abriu ticket?', value: 'abriuTicket' },
      { text: 'Última mensagem do cliente', value: 'ultimaMensagem' },
    ]

    // Achata cliente -> sessões numa lista só, uma linha por sessão, mantendo o nome do cliente em cada linha
    //
    // ATENÇÃO (fragilidade a monitorar): os chips/KPIs abaixo (qtdeTicketsAbertos, qtdeSessoesSemTicket,
    // qtdeClientesComTicket, qtdeClientesSemTicket) são calculados no front sobre `interacoesClientes`.
    // Isso só bate com a realidade porque `RelatorioService.getInteracoesClienteChatbot` busca TODAS as
    // páginas em loop antes de devolver (ver comentário lá). Se algum dia essa função voltar a devolver
    // só uma página, esses cálculos locais ficam incorretos silenciosamente — nesse caso, trocar essas
    // contagens pra virem prontas do backend (endpoint total-atendimentos-chatbot já corrigido na Fase 2).
    const sessoesPorCliente = computed(() => interacoesClientes.value
      .flatMap(cliente => cliente.sessoes.map(sessao => ({
        ...sessao,
        clienteId: cliente.clienteId,
        nomeCliente: cliente.nomeCliente,
      }))))

    const buscaCliente = ref('')

    const sessoesFiltradas = computed(() => {
      const termo = buscaCliente.value.trim().toLowerCase()

      if (!termo) return sessoesPorCliente.value

      return sessoesPorCliente.value.filter(sessao => (sessao.nomeCliente || '').toLowerCase().includes(termo))
    })

    function abriuTicket(sessao) {
      return sessao.historico.some(interacao => interacao.ticketId)
    }

    // Uma "sessão" (ChatBotControleId) pode ser reaproveitada pelo mesmo cliente ao longo do
    // período e conter mais de uma conversa/ticket distintos — por isso contamos tickets ÚNICOS
    // (não sessões) pra bater com o total real de tickets abertos pelo bot.
    const qtdeTicketsAbertos = computed(() => {
      const ticketIds = sessoesPorCliente.value
        .flatMap(sessao => sessao.historico)
        .map(interacao => interacao.ticketId)
        .filter(Boolean)

      return new Set(ticketIds).size
    })

    const qtdeSessoesSemTicket = computed(() => sessoesPorCliente.value.filter(sessao => !abriuTicket(sessao)).length)

    // Um mesmo cliente pode aparecer em mais de uma sessão no período — aqui contamos CLIENTES
    // distintos (não sessões nem tickets), então cada cliente entra só uma vez, no grupo certo:
    // "abriu ticket" se pelo menos uma das sessões dele teve ticket.
    function clienteAbriuTicket(cliente) {
      return cliente.sessoes.some(sessao => abriuTicket(sessao))
    }

    const qtdeClientesComTicket = computed(() => interacoesClientes.value
      .filter(cliente => clienteAbriuTicket(cliente)).length)

    const qtdeClientesSemTicket = computed(() => interacoesClientes.value.length - qtdeClientesComTicket.value)

    function formatarDataHora(data) {
      if (!data) return ''

      return new Date(data).toLocaleString('pt-BR')
    }

    function ultimaMensagemDoCliente(sessao) {
      const ultima = [...sessao.historico]
        .reverse()
        .find(interacao => interacao.clienteDigitou)

      return ultima ? ultima.clienteDigitou : '—'
    }

    const formRef = ref(null)

    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())
    const menu1 = ref(false)
    const menu2 = ref(false)

    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}/${month}/${year}`
    }

    const parseDate = dates => {
      if (!dates) return null
      const [day, month, year] = dates.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    async function getBots() {
      try {
        loading.value = true
        botsDisponiveis.value = await ChatBotService.get()
      } finally {
        loading.value = false
      }
    }

    async function getArvores() {
      try {
        loading.value = true
        arvoresDisponiveis.value = await ChatBotService.getArvoresDisponiveis(idBotSelecionado.value)
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => { await getBots() })

    async function getAtendimentosBot() {
      atendimentosBot.value = await RelatorioService.getRelatorioTotalAtendimentosChatbot(idBotSelecionado.value, idArvoreSelecionada.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)

      dadosBot.value = {
        nome: botsDisponiveis.value.filter(b => b.id === idBotSelecionado.value)[0].nome,
        arvore: arvoresDisponiveis.value.filter(a => a.id === idArvoreSelecionada.value)[0].nome,
      }
    }

    async function getArvoreBot() {
      arvore.value = await RelatorioService.getRelatorioChatBotArvore(idBotSelecionado.value, idArvoreSelecionada.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)
    }

    async function getPesquisaSatisfacao() {
      pesquisaSatisfacaoBot.value = await RelatorioService.getRelatorioChatBotArvorePesquisaSatisfacao(idBotSelecionado.value, idArvoreSelecionada.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)
    }

    async function getInteracoesClientes() {
      loadingInteracoesClientes.value = true
      try {
        const resultado = await RelatorioService.getInteracoesClienteChatbot(idBotSelecionado.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)
        interacoesClientes.value = resultado.clientes
      } finally {
        loadingInteracoesClientes.value = false
      }
    }

    async function filtrar() {
      if (Date.parse(filtroPeriodoFim.value) < Date.parse(filtroPeriodoInicio.value)) {
        Vue.$toast.warning('O periódo final deve ser menor que o periódo inicial!', {
          timeout: false,
        })
        loadingButton.value = false

        return
      }

      const diferenca = Date.parse(filtroPeriodoFim.value) - Date.parse(filtroPeriodoInicio.value)
      const diferencaDias = diferenca / (1000 * 3600 * 24)
      if (diferencaDias >= 366) {
        Vue.$toast.warning('A diferença entre as datas deve ser de no máximo 365 dias!', {
          timeout: false,
        })
        loadingButton.value = false

        return
      }

      if (loadingButton.value) return
      if (formRef.value.validate()) {
        loadingButton.value = true
        loadingComponentes.value = true
        await getAtendimentosBot()
        await getArvoreBot()
        await getPesquisaSatisfacao()
        await getInteracoesClientes()
        filtragemFeita.value = true
      }

      loadingComponentes.value = false
      loadingButton.value = false
    }

    function criarListasRecursivas(objeto, listaResultado, ordemPai = 1) {
      objeto.ordem = ordemPai
      listaResultado.push(objeto)

      if (objeto.nosFilhos && objeto.nosFilhos.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (let i = 0; i < objeto.nosFilhos.length; i++) {
          // A ordem dos filhos será a ordem do pai concatenada com o índice do filho
          const ordemFilho = objeto.nosFilhos.length > 0 ? ordemPai + 1 : ordemPai
          criarListasRecursivas(objeto.nosFilhos[i], listaResultado, ordemFilho)
        }
      }
    }

    const novaLista = computed(() => {
      const lista = []
      // eslint-disable-next-line no-restricted-syntax
      for (const objeto of arvore.value) {
        const listaResultado = []
        criarListasRecursivas(objeto, listaResultado)
        lista.push(listaResultado)
      }

      return lista
    })

    let maiorOrdem = 1
    async function getMaiorOrdem() {
      // eslint-disable-next-line no-restricted-syntax
      for (const listaResultado of novaLista.value) {
        // eslint-disable-next-line no-restricted-syntax
        for (const objeto of listaResultado) {
          if (objeto.ordem > maiorOrdem) {
            maiorOrdem = objeto.ordem
          }
        }
      }
    }

    async function downloadExcel() {
      loadingExcel.value = true
      try {
        if (Object.keys(novaLista.value).length === 0) {
          this.$toast.warning('Sem dados para gerar relatório!')
          return
        }

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Opções selecionadas')

        const columns = []

        await getMaiorOrdem()

        // eslint-disable-next-line no-plusplus
        for (let e = 0; e < maiorOrdem; e++) {
          columns.push(
            { header: `Titulo ${e + 1}`, key: `texto${e}`, width: 25 },
          )
        }

        columns.push({ header: 'Total Escolhas', key: 'qtdeEscolhidasNo', width: 15 })
        worksheet.columns = columns

        const totalColumns = worksheet.actualColumnCount
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const date in novaLista.value) {
          // eslint-disable-next-line no-prototype-builtins
          if (novaLista.value.hasOwnProperty(date)) {
            const dataGroup = novaLista.value[date]
            const rowToAdd = []

            // eslint-disable-next-line no-loop-func
            dataGroup.forEach(item => {
              if (item.botaoOpcaoTitle) {
                rowToAdd[item.ordem] = `${item.numero} - ${item.botaoOpcaoTitle}`
                rowToAdd[totalColumns] = item.qtdeEscolhidasNo
              } else if (item.listaOpcaoTitle) {
                rowToAdd[item.ordem] = `${item.numero} - ${item.listaOpcaoTitle}`
                rowToAdd[totalColumns] = item.qtdeEscolhidasNo
              } else {
                rowToAdd[item.ordem] = `${item.numero} - ${item.texto}`
                rowToAdd[totalColumns] = item.qtdeEscolhidasNo
              }

              worksheet.addRow(rowToAdd)
            })
          }
        }

        const rows = ref([])

        worksheet.eachRow((row, rowNumber) => {
          const rowKey = row.values

          const originalRowKey = [...rowKey]

          if (rows.value.length > 0) {
            const lastRow = rows.value[rows.value.length - 1]
            let rowChanged = false

            for (let n = 0; n < lastRow.length; n++) {
              if (lastRow[n] === rowKey[n]) {
                if (rowKey[n] && typeof rowKey[n] === 'string') {
                  rowKey[n] = ''
                  rowChanged = true
                }
              }
            }

            if (rowChanged) {
              rows.value.push(originalRowKey)

              row.values = rowKey
            } else {
              rows.value.push(rowKey)
            }
          } else {
            rows.value.push(rowKey)
          }
        })

        const worksheet2 = workbook.addWorksheet('Pesquisa')
        const columns2 = [
          { header: 'Número do protocolo', key: 'protocolo', width: 25 },
          { header: 'Nome do agente', key: 'integrante', width: 25 },
          { header: 'Nome do solicitante', key: 'solicitante', width: 25 },
          { header: 'Número do solicitante', key: 'celular', width: 25 },
          { header: 'Tipo solicitação', key: 'tipoSolicitacao', width: 25 },
          { header: 'Opção selecionada', key: 'textoNo', width: 25 },
          { header: 'Resposta do solicitante', key: 'respostaCliente', width: 25 },
        ]
        worksheet2.columns = columns2

        pesquisaSatisfacaoBot.value.forEach(el => {
          worksheet2.addRow(el)
        })

        const worksheet3 = workbook.addWorksheet('Interações por cliente')
        const columns3 = [
          { header: 'Nome do cliente', key: 'nomeCliente', width: 30 },
          { header: 'Início da sessão', key: 'dataInicio', width: 20 },
          { header: 'Data/hora da interação', key: 'dataHistorico', width: 20 },
          { header: 'Mensagem do bot', key: 'botPergunta', width: 40 },
          { header: 'Resposta do cliente', key: 'clienteDigitou', width: 40 },
          { header: 'Ticket', key: 'ticketId', width: 12 },
        ]
        worksheet3.columns = columns3

        sessoesPorCliente.value.forEach(sessao => {
          sessao.historico.forEach(interacao => {
            worksheet3.addRow({
              nomeCliente: sessao.nomeCliente,
              dataInicio: formatarDataHora(sessao.dataInicio),
              dataHistorico: formatarDataHora(interacao.dataHistorico),
              botPergunta: interacao.botPergunta,
              clienteDigitou: interacao.clienteDigitou,
              ticketId: interacao.ticketId || '',
            })
          })
        })

        const buffer = await workbook.xlsx.writeBuffer()

        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        FileSaver.saveAs(blob, 'Relatorio_bot.xlsx')
      } catch (error) {
        loadingExcel.value = false
        console.error('Erro durante a geração ou download do relatório:', error)
      }
    }

    return {
      formRef,
      dadosBot,
      botsDisponiveis,
      idBotSelecionado,
      arvoresDisponiveis,
      idArvoreSelecionada,
      loading,
      loadingComponentes,
      loadingButton,
      loadingExcel,
      filtragemFeita,
      atendimentosBot,
      arvore,
      sessoesPorCliente,
      sessoesFiltradas,
      buscaCliente,
      qtdeTicketsAbertos,
      qtdeSessoesSemTicket,
      qtdeClientesComTicket,
      qtdeClientesSemTicket,
      loadingInteracoesClientes,
      headersSessoesPorCliente,
      formatarDataHora,
      ultimaMensagemDoCliente,
      abriuTicket,
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      downloadExcel,
      parseDate,
      getArvores,
      filtrar,
      icons: { mdiCalendar, mdiFileExcelOutline, mdiMagnify },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>

  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>
